export default {
  url: 'https://ipapi.co/json'
};
